module.exports = __webpack_public_path__ + "media/images/new-ui-images/schedule-icon-8e11759e0c0dbb03508c2653bac2533a.svg";